/* src/app/shared/contract/contract-seller-list/contract-seller-filters/contract-seller-filters.component.scss */
.filter-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.padding-margin {
  padding-right: 10px;
  margin-top: 15px;
}
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
/*# sourceMappingURL=contract-seller-filters.component.css.map */
